<template>
  <div class="container-fluid mt-4 SlimTDs">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Ödeme Türü Düzenle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn class="mr-3" type="button" variant="danger" to="/Settings/PaymentTypes" :size="ButtonSize">
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1" v-if="ScreenWidth > 380">Ödeme Türleri</span>
        </b-btn>

        <b-btn class="mr-3" type="button" variant="info" @click="Refresh()" :size="ButtonSize">
          <i class="material-icons mifix">refresh</i>
          <span class="ml-1" v-if="ScreenWidth > 360">Yenile</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-alert show variant="danger" v-if="Object.keys(PaymentType).length === 0">Hata!</b-alert>

    <b-alert
      show
      variant="info"
      v-if="Object.keys(PaymentType).length > 0"
    >Düzenlenen Ödeme Türü: {{ PaymentTypeOldName }}</b-alert>

    <form @submit.prevent="SavePaymentType" v-if="Object.keys(PaymentType).length > 0">
      <b-form-group
        class="formgroup"
        :label="Enums[index]"
        v-for="(property, index) in PaymentTypeGUI"
        :key="index"
      >
        <b-form-input
          type="text"
          v-model="PaymentType[index]"
          @keypress.enter.prevent="SavePaymentType"
        ></b-form-input>
      </b-form-group>

      <div class="m-t-40 d-block border-top pt-3 pl-3">
        <b-btn type="submit" variant="success" size="lg">
          <i class="material-icons mifix">save</i>
          <span class="ml-1">Kaydet</span>
        </b-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../../Service";

export default {
  data() {
    return {
      Enums: {
        Name: "Ödeme Türü Adı",
        Sort: "Sıralama"
      },
      PaymentTypeOldName: "",
      PaymentType: {}
    };
  },
  async created() {
    await this.Refresh();
  },
  computed: {
    ...mapState(["StoreData", "ScreenWidth", "ButtonSize"]),
    ParamID() {
      return this.$route.params.ID;
    },
    PaymentTypeGUI() {
      return Object.filterKey(
        this.PaymentType,
        x => ["Name", "Sort"].indexOf(x) !== -1
      );
    }
  },
  methods: {
    async Refresh() {
      if (!this.StoreData.PaymentTypes) return;

      let _PaymentTypes = {};

      for (let i in this.StoreData.PaymentTypes) {
        let _PT = this.StoreData.PaymentTypes[i];
        _PaymentTypes[_PT.ID] = Object.assign({}, _PT);
      }

      if (!_PaymentTypes[this.ParamID]) return;

      let _PaymentType = Object.assign({}, _PaymentTypes[this.ParamID]);

      delete _PaymentType.Tables;

      await this.$set(this, "PaymentTypeOldName", _PaymentType.Name);
      await this.$set(this, "PaymentType", _PaymentType);

      await this.$nextTick();
      await this.$forceUpdate();
    },
    async SavePaymentType() {
      await this.$store.dispatch("AddLoading", "SavePaymentType");

      await Services.Nozich.Send(
        "SavePaymentType",
        {
          ID: this.ParamID,
          PaymentType: this.PaymentType
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "SavePaymentType");

          if (Data.Status === "Success") {
            await this.$router.push("/Settings/PaymentTypes");
          }
        }
      );
    }
  },
  async mounted() {
    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
    });
  }
};
</script>
